import _ from 'lodash';
import React from 'react';
import update from 'react-addons-update';

import Filter from './filter';


export default class Filters extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = _.mapValues(
            _.mapKeys(this.props.filters, filter => filter.field),
            () => [],
        );
        this.state = {
            ...this.state,
            openedFilter: null,
        };
    }

    openFilter(index) {
        this.setState({openedFilter: index});
    }

    closeFilters() {
        this.setState({openedFilter: null});
    }

    updateFilters(filter) {
        var newState = update(this.state, {
            [filter.field]: {$set: filter.values},
        });
        this.setState(newState);
    }

    render() {
        var filters = _.map(this.props.filters, (filter, index) => {
            if (!filter.label)
                return null;
            return <Filter
                updateFilters={this.updateFilters.bind(this)}
                {...filter}
                key={index}
                index={index}
                isOpen={index === this.state.openedFilter}
                openFilter={this.openFilter.bind(this, index)}
                close={() => {
                    if (this.state.openedFilter === index)
                        this.closeFilters.bind(this)();
                }}
            />;
        });
        return <ul style={{padding: 0, margin: 0}}>
            {filters}
        </ul>;
    }
}
